
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoPo05PendingPIforIrGrid extends Serenity.EntityGrid<PoPo05PendingPIforIrRow, any> {
        protected getColumnsKey() { return PoPo05PendingPIforIrColumns.columnsKey; }
        protected getDialogType() { return PoPo05PendingPIforIrDialog; }
        protected getIdProperty() { return PoPo05PendingPIforIrRow.idProperty; }
        protected getInsertPermission() { return PoPo05PendingPIforIrRow.insertPermission; }
        protected getLocalTextPrefix() { return PoPo05PendingPIforIrRow.localTextPrefix; }
        protected getService() { return PoPo05PendingPIforIrService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

            // this.tree = new Serenity.TreeGridMixin({
            //     grid: this,
            //     initialCollapse: ()=> false, //ขยาย ไม่ขยาย
            //     toggleField: ReportPendingPORow.Fields.SysDocNo,
            //     getParentId: x=> {
            //         return x.PerentDt
            //     }

            // });  ทำกริตtree แต่ต้องเขียนวิว มาให้รองรับ
        }

        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();

            // need to register this plugin for grouping or you'll have errors
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
    
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                
            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });
    
            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["  "]);
        }
        
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            opt.groupingPanel = true;
            return opt;
        }
        


        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: PoPo05PendingPIforIrService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );
            return buttons;
        }
    }
}